import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowRight,
  FaChartLine,
  FaChartBar,
  FaExchangeAlt,
  FaLayerGroup,
  FaMedal,
  FaTags,
} from "react-icons/fa";
import InsightsBackButton from "../shared/InsightsBackButton";
import "./MarketInsights.css";

const insightModules = [
  {
    key: "timeline",
    eyebrow: "Catalog history",
    title: "Hobby Timeline",
    description:
      "Explore cards cataloged by year and see how sets, brands, releases, and sports change across hobby history.",
    icon: FaChartLine,
    action: "Explore Timeline",
    path: "/insights/market/timeline",
    status: "Available",
  },
  {
    key: "sales",
    eyebrow: "Market history",
    title: "Sales Trends",
    description:
      "Follow sold-card prices, transaction volume, raw versus graded results, and changing market behavior over time.",
    icon: FaChartBar,
    action: "Coming Soon",
    status: "Planned",
  },
  {
    key: "activity",
    eyebrow: "Supply & demand",
    title: "Market Activity",
    description:
      "See where listings and sales are concentrated and how collector activity changes across the hobby.",
    icon: FaExchangeAlt,
    action: "Coming Soon",
    status: "Planned",
  },
  {
    key: "movers",
    eyebrow: "Price movement",
    title: "Price Movers",
    description:
      "Surface meaningful changes in card and set prices once Hobbli has enough durable sales history to support them.",
    icon: FaTags,
    action: "Coming Soon",
    status: "Planned",
  },
  {
    key: "breakdown",
    eyebrow: "Hobby structure",
    title: "Hobby Breakdown",
    description:
      "Compare the hobby by sport, era, manufacturer, brand, family, and other catalog dimensions.",
    icon: FaLayerGroup,
    action: "Coming Soon",
    status: "Planned",
  },
  {
    key: "grading",
    eyebrow: "Graded market",
    title: "Grading Insights",
    description:
      "Compare grades, grading companies, and graded-market behavior as Hobbli's market dataset expands.",
    icon: FaMedal,
    action: "Coming Soon",
    status: "Planned",
  },
];

export default function MarketInsights() {
  const navigate = useNavigate();

  return (
    <main className="market-insights market-insights-home">
      <InsightsBackButton />

      <section className="market-hero market-home-hero">
        <div>
          <span className="market-eyebrow">Explore Hobbli data</span>
          <h1>Market Insights</h1>
          <p>
            Explore the hobby through Hobbli's growing catalog and market data.
            Choose an insight below to dig into hobby history, sales, activity,
            pricing, and collecting trends.
          </p>
        </div>
        <div className="market-hero-icon"><FaChartBar /></div>
      </section>

      <section className="market-home-section">
        <div className="market-panel-heading market-home-heading">
          <div>
            <span className="market-eyebrow">Choose an insight</span>
            <h2>Explore the hobby</h2>
          </div>
          <span>More insights will unlock as Hobbli's market history grows.</span>
        </div>

        <div className="market-module-grid">
          {insightModules.map((module) => {
            const Icon = module.icon;
            const available = Boolean(module.path);
            return (
              <button
                type="button"
                key={module.key}
                className={`market-module-card ${available ? "market-module-card--live" : "market-module-card--planned"}`}
                onClick={available ? () => navigate(module.path) : undefined}
                disabled={!available}
              >
                <div className="market-module-top">
                  <span className="market-module-icon"><Icon /></span>
                  <span className={`market-module-status ${available ? "live" : ""}`}>{module.status}</span>
                </div>
                <div className="market-module-body">
                  <span className="market-eyebrow">{module.eyebrow}</span>
                  <h3>{module.title}</h3>
                  <p>{module.description}</p>
                </div>
                <div className="market-module-footer">
                  <span>{module.action}</span>
                  {available && <FaArrowRight />}
                </div>
              </button>
            );
          })}
        </div>
      </section>

      <section className="market-home-note">
        <strong>Built from Hobbli data.</strong>
        <span>
          Catalog insights reflect the cards and sets currently cataloged in Hobbli. Market insights will
          use Hobbli's durable listing, sales, and pricing history as those datasets grow.
        </span>
      </section>
    </main>
  );
}
